import { initializeApp } from "firebase/app";
import { FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { logDebug } from "./LocalLogger";
import uiStore from "./MobxStore";

const firebaseConfigProd = {
	apiKey: "AIzaSyCjGkpnA9KSgyTHY1yU9eJt6KmON-jaV74",
	authDomain: "hikelikeme-c5474.firebaseapp.com",
	projectId: "hikelikeme-c5474",
	storageBucket: "hikelikeme-c5474.firebasestorage.app",
	messagingSenderId: "582441090269",
	appId: "1:582441090269:web:e4c06b65207db938826f34",
	measurementId: "G-5BR1XQKJXG",
};

const firebaseConfigDev = {
	apiKey: "AIzaSyAzPA4KrC4qcxgFMLBzSDP-_3g9jM7TQzU",
	authDomain: "hikelikeme-dev.firebaseapp.com",
	projectId: "hikelikeme-dev",
	storageBucket: "hikelikeme-dev.appspot.com",
	messagingSenderId: "101670291106",
	appId: "1:101670291106:web:62eb2028fa3ebb8c4439fb",
	measurementId: "G-Y90QHMFQWW",
};

const isLocalhost = location.href.includes("localhost") || location.href.includes("localhost");
const isForceProd = location.href.includes("-prod");
const isDev = (isLocalhost || location.href.includes("-dev")) && !isForceProd;
// alert(`isDev: ${isDev}, isForceProd: ${isForceProd}, isLocalhost: ${isLocalhost}`);
const forceDev = false;
const forceProd = false || isForceProd;
let firebaseConfig = isDev ? firebaseConfigDev : firebaseConfigProd;
if (forceDev) {
	firebaseConfig = firebaseConfigDev;
}
if (forceProd) {
	firebaseConfig = firebaseConfigProd;
}
export function getCurrentFirebaseConfig() {
	return firebaseConfig;
}

logDebug("Firebase config: ", firebaseConfig.projectId);

export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp); // auth instance
export const googleProvider = new GoogleAuthProvider(); // Google SSO

export const signInWithGoogle = () => {
	signInWithPopup(auth, googleProvider)
		.then((result) => {
			const credential = GoogleAuthProvider.credentialFromResult(result);
			if (credential) {
				// const token = credential.accessToken;
				uiStore.user = result.user; // Set the user in the MobX store
				console.log("User signed in: ", uiStore.user);
			}
		})
		.catch((error) => {
			const errorCode = error.code;
			const errorMessage = error.message;
			console.error("Error signing in with Google: ", errorCode, errorMessage);
		});
};

const GoogleSSO: React.FC = () => {
	const onClick = async () => {
		signInWithGoogle();
	};

	return (
		<button onClick={onClick} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
			Sign in with Google
		</button>
	);
};
export { GoogleSSO };
